import { render, staticRenderFns } from "./gymRatingGraphicAvgStudentBrenchPress.vue?vue&type=template&id=37ab8916&"
import script from "./gymRatingGraphicAvgStudentBrenchPress.js?vue&type=script&lang=js&"
export * from "./gymRatingGraphicAvgStudentBrenchPress.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports